import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { apiRoutes } from "configs/apiRoutes";
import instance from "api/apiClient";

export interface LogItem {
  hash: string;
  service: string;
  type: string;
  message: string;
  created: string;
}
interface GamesState {
  list: LogItem[];
  item?: LogItem;
  activePage: number;
  totalPages: number;
  totalItems: number;
  isListFetched: boolean;
}
interface GetListPayload {
  limit: number;
  offset: number;
  types?: string[];
  services: string[];
}

export const getLogsList = createAsyncThunk(
  "logs/list",
  async (data: GetListPayload) => {
    try {
      const result = await instance.post(`${apiRoutes.logsList}`, { ...data });
      return result.data;
    } catch (error) {
      return undefined;
    }
  },
);

const initialState: GamesState = {
  list: [],
  isListFetched: false,
  activePage: 1,
  totalItems: 0,
  totalPages: 0,
};

export const logsSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    handlePaginate: (state: GamesState, action: PayloadAction<number>) => {
      state.activePage = action.payload;
      state.isListFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLogsList.fulfilled, (state, action) => {
      state.isListFetched = true;
      state.list = action.payload?.items ?? [];
      state.totalItems = action.payload?.totalItems ?? 1;
      state.totalPages = action.payload?.totalPages ?? 1;
    });
  },
});

export const { handlePaginate } = logsSlice.actions;
